<ng-container *ngFor="let faqContent of faqItems" [ngSwitch]="faqContent.type">
	<ng-container *ngSwitchCase="'text'">
		<p *ngFor="let texte of faqContent.contenu" [innerHtml]="texte"></p>
	</ng-container>

	<ul *ngSwitchCase="'liste'">
		<li *ngFor="let texte of faqContent.contenu" [innerHtml]="texte"></li>
	</ul>

	<ol *ngSwitchCase="'enumeration'">
		<li *ngFor="let texte of faqContent.contenu" [innerHtml]="texte"></li>
	</ol>

	<ng-container *ngSwitchCase="'lien'">
		<dd1pnds-ng-link-v2 [isDisplayedMatIconLeft]="false" [linkLabel]="faqContent.contenu.label"
			(linkClicked)="redirectToPage(faqContent.contenu.url)" class="text-underline">
		</dd1pnds-ng-link-v2>
	</ng-container>
</ng-container>
